import * as Yup from 'yup';

const supportingInfoSchema = Yup.object().shape({
  category: Yup.string().required('Category is required'),
  // code: Yup.string()
  //   .nullable()
  //   .test('code-required', 'Code is required for this category', function (value) {
  //     const { category } = this.parent;
  //     const categoriesRequiringCode = ['chief-complaint', 'investigation-result'];
  //     return !categoriesRequiringCode.includes(category) || (categoriesRequiringCode.includes(category) && !!value);
  //   })
  //   .test(
  //     'valid-investigation-code',
  //     'Code must be one of IRA, INP, IRP, NA, or Other for investigation result',
  //     function (value) {
  //       const { category } = this.parent;
  //       const validInvestigationCodes = ['IRA', 'INP', 'IRP', 'NA', 'Other'];
  //       if (category === 'investigation-result' && value) {
  //         return validInvestigationCodes.includes(value);
  //       }
  //       return true;
  //     }
  //   ),
  codeText: Yup.string().nullable(),
  value: Yup.string()
    .nullable()
    .test('value-required', 'Value is required for this category', function (value) {
      const { category } = this.parent;
      const categoriesRequiringValue = [
        'chief-complaint',
        'history-of-present-illness',
        'patient-history',
        'physical-examination',
        'treatment-plan'
      ];
      return !categoriesRequiringValue.includes(category) || (categoriesRequiringValue.includes(category) && !!value);
    }),
  // .test(
  //   "required-value-for-IRA",
  //   "Value is required when code is 'IRA' for investigation result",
  //   function (value) {
  //     const { category, code } = this.parent;
  //     return !(
  //       category === "investigation-result" &&
  //       code === "IRA" &&
  //       !value
  //     );
  //   }
  // ),

  reason: Yup.string()
    .nullable()
    .test(
      'reason-required-if-no-value',
      'Reason is required if value is not entered for the category',
      function (value) {
        const { value: enteredValue, category } = this.parent;
        const categoriesRequiringReason = [
          'vital-sign-weight',
          'vital-sign-diastolic',
          'vital-sign-height',
          'vital-sign-systolic',
          'pulse',
          'oxygen-saturation',
          'temperature',
          'respiratory-rate'
        ];
        return !categoriesRequiringReason.includes(category) || enteredValue || !!value;
      }
    ),
  attachment: Yup.string()
    .nullable()
    .test(
      'image-required-for-IRA',
      "Image is required for 'IRA' code in investigation result category",
      function (value) {
        const { category, code } = this.parent;
        return !(category === 'investigation-result' && code === 'IRA' && !value);
      }
    ),
  fileName: Yup.string()
    .nullable()
    .test(
      'image-title-required-for-IRA',
      "Image title is required for 'IRA' code in investigation result category",
      function (value) {
        const { category, code } = this.parent;
        return !(category === 'investigation-result' && code === 'IRA' && !value);
      }
    ),
  fileType: Yup.string()
    .nullable()
    .test(
      'image-content-type-required-for-IRA',
      "Image type is required for 'IRA' code in investigation result category",
      function (value) {
        const { category, code } = this.parent;
        return !(category === 'investigation-result' && code === 'IRA' && !value);
      }
    ),

  startDate: Yup.date()
    .nullable()
    .test(
      'start-date-required',
      'Start date is required for specific categories and when vital signs are entered',
      function (value) {
        const { category, vitalSignValues, value: enteredValue } = this.parent;

        // Categories that require a start date
        const categoriesRequiringStartDate = ['lab-test', 'ventilation-hours', 'icu-hours'];

        // Check if the current category is one that requires a start date
        const isCategoryRequiringStartDate = categoriesRequiringStartDate.includes(category);

        // If the category is one of those, ensure startDate is provided
        if (isCategoryRequiringStartDate && !value) {
          return this.createError({
            message: 'Start date is required for this category'
          });
        }

        // Vital sign categories to check
        const vitalSignCategories = [
          'vital-sign-weight',
          'vital-sign-diastolic',
          'vital-sign-height',
          'vital-sign-systolic',
          'pulse',
          'oxygen-saturation',
          'temperature',
          'respiratory-rate'
        ];

        // Check if the current category is a vital sign category
        const isVitalSignCategory = vitalSignCategories.includes(category);

        // If a vital sign category has a value entered, startDate should be required
        if (isVitalSignCategory && enteredValue && !value) {
          return this.createError({
            message: 'Start date is required when a vital sign value is entered'
          });
        }

        return true; // Pass validation if none of the above conditions are met
      }
    )
});

export const preAuthValidationSchema = t =>
  Yup.object().shape({
    isFollowUpReq: Yup.boolean(),
    isNewBorn: Yup.boolean(),
    isReferral: Yup.boolean(),
    patientId: Yup.mixed().required(t('Patient is required')),
    patientName: Yup.string().nullable(),
    subscriberName: Yup.string().nullable(),
    insurancePlanId: Yup.mixed().required(t('Insurance Plan is required')),
    subscriber: Yup.mixed().nullable(),
    payerId: Yup.mixed().nullable(),
    payerName: Yup.string().nullable(),
    insurancePlanIndex: Yup.string(),
    dateOrdered: Yup.string().required(t('Date ordered is required')),
    claimType: Yup.string().required(t('Type is required')),
    subType: Yup.string().required(t('Sub Type is required')),
    encounterStatus: Yup.string()
      .nullable()
      .test(t('encounterStatus-required'), t('status is required'), function (value) {
        const { claimType } = this.parent;

        if (claimType === 'institutional' || claimType === 'professional' || claimType === 'oral') {
          return !!value;
        }
        return true;
      }),
    encounterClass: Yup.string()
      .nullable()
      .test(t('encounterClass-required'), t('Class is required'), function (value) {
        const { claimType } = this.parent;

        if (claimType === 'institutional' || claimType === 'professional' || claimType === 'oral') {
          return !!value;
        }
        return true;
      }),
    serviceType: Yup.string().nullable(),
    periodStart: Yup.date()
      .nullable()
      .test('periodStart-required', 'Periiod start is required', function (value) {
        const { claimType } = this.parent;

        if (claimType === 'institutional' || claimType === 'professional' || claimType === 'oral') {
          return !!value;
        }
        return true;
      }),
    periodEnd: Yup.date()
      .nullable()
      .test('periodEnd-required', 'Period End is required', function (value) {
        const { encounterClass } = this.parent;

        if (encounterClass === 'IMP') {
          return !!value;
        }
        return true;
      }),
    encounterPriority: Yup.string().nullable(),
    serviceEventType: Yup.string()
      .nullable()
      .test('serviceEventType-required', t('Service Event Type is required'), function (value) {
        const { claimType } = this.parent;

        if (claimType === 'professional' || claimType === 'oral') {
          return !!value;
        }
        return true;
      }),
    emergencyArivalCode: Yup.string()
      .nullable()
      .test('emergencyArivalCode-required', t('Emergency Arival Code is required'), function (value) {
        const { claimType, subType } = this.parent;

        if (claimType === 'professional' && subType === 'emr') {
          return !!value;
        }
        return true;
      }),
    dischargeDisposition: Yup.string()
      .nullable()
      .test('dischargeDisposition-required', t('Discharge Disposition is required'), function (value) {
        const { encounterClass } = this.parent;

        if (encounterClass === 'IMP') {
          return !!value;
        }
        return true;
      }),
    emergencyServiceDate: Yup.string()
      .nullable()
      .test('emergencyServiceDate-required', t('Emergency Service Date is required'), function (value) {
        const { claimType, subType } = this.parent;

        if (claimType === 'professional' && subType === 'emr') {
          return !!value;
        }
        return true;
      }),
    triageCategory: Yup.string()
      .nullable()
      .test('triageCategory-required', t('Triage Category is required'), function (value) {
        const { claimType, subType } = this.parent;

        if (claimType === 'professional' && subType === 'emr') {
          return !!value;
        }
        return true;
      }),
    triageDate: Yup.string()
      .nullable()
      .test('triageDate-required', t('Triage Date is required'), function (value) {
        const { claimType, subType } = this.parent;

        if (claimType === 'professional' && subType === 'emr') {
          return !!value;
        }
        return true;
      }),
    adminSource: Yup.string()
      .nullable()
      .test('adminSource-required', t('Admin Source is required'), function (value) {
        const { claimType } = this.parent;

        if (claimType === 'institutional') {
          return !!value;
        }
        return true;
      }),
    admissionSpeciality: Yup.string()
      .nullable()
      .test('admissionSpeciality-required', t('Admission Speciality is required'), function (value) {
        const { claimType } = this.parent;

        if (claimType === 'institutional') {
          return !!value;
        }
        return true;
      }),
    dischargeSpeciality: Yup.string()
      .nullable()
      .test('dischargeSpeciality-required', t('Discharge Speciality is required'), function (value) {
        const { claimType } = this.parent;

        if (claimType === 'institutional') {
          return !!value;
        }
        return true;
      }),
    intendedLengthOfStay: Yup.string()
      .nullable()
      .test('intendedLengthOfStay-required', t('Intended Length Of Stay is required'), function (value) {
        const { claimType } = this.parent;

        if (claimType === 'institutional') {
          return !!value;
        }
        return true;
      }),
    eligibilityResponseIdentifierValue: Yup.string(),
    eligibilityResponseIdentifierUrl: Yup.string(),
    offlineEligibilityId: Yup.string(),
    offlineEligibilityDate: Yup.string(),
    priority: Yup.string(),
    payeeType: Yup.string(),
    payee: Yup.string(),
    relatedPreAuthRefNo: Yup.string(),
    referringProvider: Yup.string(),
    careTeamsArr: Yup.array()
      .of(
        Yup.object().shape({
          practitioner: Yup.string().required(t('Practitioner is required')),
          practitionerName: Yup.string(),
          practitioner_role: Yup.string(),
          care_team_role: Yup.string().required(t('Care team role is required')),
          qualification: Yup.string().required(t('Qualification is required'))
        })
      )
      .min(1, t('At least 1 care team member is required'))
      .required(t('Care Team array is required')),
    diagnosisArr: Yup.array()
      .of(
        Yup.object().shape({
          id: Yup.number(),
          codeDescription: Yup.string().required(t('Code Description is required')),
          type: Yup.string().required(t('Type is required')),
          on_admission: Yup.boolean().required(t('On Admission is required')),
          codeId: Yup.string().required(t('Code ID is required')),
          condition_on_set: Yup.string()
            .nullable()
            .test('condition_on_set-required', t('Condition Onset is required'), function (value) {
              const { claimType } = this.parent;

              if (claimType === 'institutional') {
                return !!value;
              }
              return true;
            })
        })
      )
      .min(1, t('At least 1 diagnose is required'))
      .required(t('Diagnosis array is required')),
    supportingInfos: Yup.array()
      .of(supportingInfoSchema)
      .min(1, t('At least 1 supporting info is required'))
      .required(t('Supporting info array is required'))
      .test('required-categories', function (supportingInfos) {
        const { claimType, isNewBorn } = this.parent;

        // Define required categories for each claim type
        const requiredCategoriesByType = {
          professional: [
            'chief-complaint',
            'vital-sign-weight',
            'vital-sign-diastolic',
            'vital-sign-height',
            'vital-sign-systolic',
            'treatment-plan',
            'history-of-present-illness',
            'patient-history',
            'physical-examination',
            'pulse',
            'oxygen-saturation',
            'temperature',
            'respiratory-rate',
            'investigation-result'
          ],
          institutional: [
            'chief-complaint',
            'vital-sign-weight',
            'vital-sign-diastolic',
            'vital-sign-height',
            'vital-sign-systolic',
            'treatment-plan',
            'history-of-present-illness',
            'patient-history',
            'physical-examination',
            'estimated-Length-of-Stay',
            'pulse',
            'oxygen-saturation',
            'temperature',
            'respiratory-rate',
            'investigation-result'
          ],
          oral: [
            'chief-complaint',
            'treatment-plan',
            'history-of-present-illness',
            'patient-history',
            'physical-examination',
            'investigation-result'
          ],
          vission: [
            'treatment-plan',
            'history-of-present-illness',
            'patient-history',
            'physical-examination',
            'investigation-result'
          ],
          pharmacy: [
            'treatment-plan',
            'history-of-present-illness',
            'patient-history',
            'physical-examination',
            'investigation-result'
          ]
        };

        // Initial required categories based on claim type
        let requiredCategories = [...(requiredCategoriesByType[claimType] || [])];

        // Add newborn-specific categories when applicable
        if (isNewBorn) {
          if (claimType === 'professional') {
            requiredCategories.push('birth-weight');
          } else if (claimType === 'institutional') {
            requiredCategories.push('birth-weight', 'admission-weight');
          }
        } else {
          // Remove newborn-specific categories if isNewBorn is false
          requiredCategories = requiredCategories.filter(
            category => category !== 'birth-weight' && category !== 'admission-weight'
          );
        }

        // Extract the categories present in supportingInfos
        const categories = supportingInfos ? supportingInfos.map(info => info.category) : [];

        // Check for missing categories
        const missingCategories = requiredCategories.filter(category => !categories.includes(category));

        // If there are missing categories, return a validation error message
        if (missingCategories.length > 0) {
          return this.createError({
            message: `The following categories are missing for ${claimType} type${
              isNewBorn ? ' (Newborn)' : ''
            }: ${missingCategories.join(', ')}`
          });
        }

        return true;
      }),

    items: Yup.array()
      .of(
        Yup.object().shape({
          // Define the schema for supporting info object here
        })
      )
      .min(1, t('At least 1 item is required'))
    // Define the schema for the remaining fields here
  });

export const claimsValidationSchema = t =>
  Yup.object().shape({
    refTransactionId: Yup.mixed().nullable(),
    isFollowUpReq: Yup.boolean(),
    isNewBorn: Yup.boolean(),
    isReferral: Yup.boolean(),
    patientId: Yup.mixed().required(t('Patient is required')),
    patientName: Yup.string().nullable(),
    subscriberName: Yup.string().nullable(),
    insurancePlanId: Yup.mixed().required(t('Insurance Plan is required')),
    subscriber: Yup.mixed().nullable(),
    payerId: Yup.mixed().nullable(),
    payerName: Yup.string().nullable(),
    insurancePlanIndex: Yup.string(),
    dateOrdered: Yup.string().required(t('Date Ordered is required')),
    claimType: Yup.string().required(t('Claim Type is required')),
    subType: Yup.string().required(t('Sub Type is required')),
    encounterStatus: Yup.string()
      .nullable()
      .test('encounterStatus-required', t('status is required'), function (value) {
        const { claimType } = this.parent;

        if (claimType === 'institutional' || claimType === 'professional' || claimType === 'oral') {
          return !!value;
        }
        return true;
      }),
    encounterClass: Yup.string()
      .nullable()
      .test('encounterClass-required', t('Class is required'), function (value) {
        const { claimType } = this.parent;

        if (claimType === 'institutional' || claimType === 'professional' || claimType === 'oral') {
          return !!value;
        }
        return true;
      }),
    serviceType: Yup.string().nullable(),
    periodStart: Yup.date()
      .nullable()
      .test('periodStart-required', t('Periiod start is required'), function (value) {
        const { claimType } = this.parent;

        if (claimType === 'institutional' || claimType === 'professional' || claimType === 'oral') {
          return !!value;
        }
        return true;
      }),
    periodEnd: Yup.date()
      .nullable()
      .test('periodEnd-required', t('Period End is required'), function (value) {
        const { encounterClass } = this.parent;

        if (encounterClass === 'IMP') {
          return !!value;
        }
        return true;
      }),
    encounterPriority: Yup.string().nullable(),
    serviceEventType: Yup.string()
      .nullable()
      .test('serviceEventType-required', t('Service Event Type is required'), function (value) {
        const { claimType } = this.parent;

        if (claimType === 'professional' || claimType === 'oral') {
          return !!value;
        }
        return true;
      }),
    emergencyArivalCode: Yup.string()
      .nullable()
      .test('emergencyArivalCode-required', t('Emergency Arival Code is required'), function (value) {
        const { claimType, subType } = this.parent;

        if (claimType === 'professional' && subType === 'emr') {
          return !!value;
        }
        return true;
      }),
    emergencyServiceDate: Yup.string()
      .nullable()
      .test('emergencyServiceDate-required', t('Emergency Service Date is required'), function (value) {
        const { claimType, subType } = this.parent;

        if (claimType === 'professional' && subType === 'emr') {
          return !!value;
        }
        return true;
      }),
    triageCategory: Yup.string()
      .nullable()
      .test('triageCategory-required', t('Triage Category is required'), function (value) {
        const { claimType, subType } = this.parent;

        if (claimType === 'professional' && subType === 'emr') {
          return !!value;
        }
        return true;
      }),
    triageDate: Yup.string()
      .nullable()
      .test('triageDate-required', t('Triage Date is required'), function (value) {
        const { claimType, subType } = this.parent;

        if (claimType === 'professional' && subType === 'emr') {
          return !!value;
        }
        return true;
      }),
    adminSource: Yup.string()
      .nullable()
      .test('adminSource-required', t('Admin Source is required'), function (value) {
        const { claimType } = this.parent;

        if (claimType === 'institutional') {
          return !!value;
        }
        return true;
      }),
    admissionSpeciality: Yup.string()
      .nullable()
      .test('admissionSpeciality-required', t('Admission Speciality is required'), function (value) {
        const { claimType } = this.parent;

        if (claimType === 'institutional') {
          return !!value;
        }
        return true;
      }),
    dischargeSpeciality: Yup.string()
      .nullable()
      .test('dischargeSpeciality-required', t('Discharge Speciality is required'), function (value) {
        const { claimType } = this.parent;

        if (claimType === 'institutional') {
          return !!value;
        }
        return true;
      }),
    intendedLengthOfStay: Yup.string()
      .nullable()
      .test('intendedLengthOfStay-required', t('Intended Length Of Stay is required'), function (value) {
        const { claimType } = this.parent;

        if (claimType === 'institutional') {
          return !!value;
        }
        return true;
      }),
    dischargeDisposition: Yup.string()
      .nullable()
      .test('dischargeDisposition-required', t('Discharge Disposition is required'), function (value) {
        const { encounterClass } = this.parent;

        if (encounterClass === 'IMP') {
          return !!value;
        }
        return true;
      }),

    eligibilityResponseIdentifierValue: Yup.string()
      .nullable()
      .test('required', t('Eligibility Res Identifier (URL) is required'), function (value) {
        const { eligibilityResponseIdentifierUrl } = this.parent;
        return !!eligibilityResponseIdentifierUrl ? !!value : true;
      }),
    eligibilityResponseIdentifierUrl: Yup.string()
      .nullable()
      .test('required', t('Eligibility Res Identifier (URL) is required'), function (value) {
        const { eligibilityResponseIdentifierValue } = this.parent;
        return !!eligibilityResponseIdentifierValue ? !!value : true;
      }),
    offlineEligibilityId: Yup.string()
      .nullable()
      .test('required', t('Offline Eligibility Id is required'), function (value) {
        const { offlineEligibilityDate } = this.parent;
        return !!offlineEligibilityDate ? !!value : true;
      }),
    offlineEligibilityDate: Yup.string()
      .nullable()
      .test('required', t('Offline Eligibility Date is required'), function (value) {
        const { offlineEligibilityId } = this.parent;
        return !!offlineEligibilityId ? !!value : true;
      }),
    preAuthRespValue: Yup.string()
      .nullable()
      .test('required', t('Preauth Res Value is required'), function (value) {
        const { preAuthRespUrl } = this.parent;
        return !!preAuthRespUrl ? !!value : true;
      }),
    preAuthRespUrl: Yup.string()
      .nullable()
      .test('required', t('Preauth Res URL is required'), function (value) {
        const { preAuthRespValue } = this.parent;
        return !!preAuthRespValue ? !!value : true;
      }),

    preAuthRefNo: Yup.string()
      .nullable()
      .test('required', t('Preauth Ref No. is required'), function (value) {
        const { offlinePreAuthDate } = this.parent;
        return !!offlinePreAuthDate ? !!value : true;
      }),
    offlinePreAuthDate: Yup.string()
      .nullable()
      .test('required', t('Preauth Ref Date is required'), function (value) {
        const { preAuthRefNo } = this.parent;
        return !!preAuthRefNo ? !!value : true;
      }),

    episodeNo: Yup.string().required(t('Episode No is required')),
    priority: Yup.string(),
    payeeType: Yup.string(),
    payee: Yup.string(),
    relatedPreAuthRefNo: Yup.string(),
    referringProvider: Yup.string(),
    careTeamsArr: Yup.array()
      .of(
        Yup.object().shape({
          practitioner: Yup.string().required(t('Practitioner is required')),
          practitionerName: Yup.string(),
          practitioner_role: Yup.string(),
          care_team_role: Yup.string().required(t('Care team role is required')),
          qualification: Yup.string().required(t('Qualification is required'))
        })
      )
      .min(1, t('At least 1 care team member is required'))
      .required(t('Care Team array is required')),
    // diagnosisArr: Yup.array()
    //   .of(
    //     Yup.object().shape({
    //       id: Yup.number(),
    //       codeDescription: Yup.string(),
    //       type: Yup.string(),
    //       on_admission: Yup.boolean(),
    //       codeId: Yup.string(),
    //     })
    //   )
    //   .min(1, "At least 1 diagnose is required"),

    diagnosisArr: Yup.array()
      .of(
        Yup.object().shape({
          id: Yup.number(),
          codeDescription: Yup.string().required(t('Code Description is required')),
          type: Yup.string().required(t('Type is required')),
          on_admission: Yup.boolean().required(t('On Admission is required')),
          codeId: Yup.string().required(t('Code ID is required')),
          condition_on_set: Yup.string()
            .nullable()
            .test('condition_on_set-required', t('Condition Onset is required'), function (value) {
              const { claimType } = this.parent;

              if (claimType === 'institutional') {
                return !!value;
              }
              return true;
            })
        })
      )
      .min(1, t('At least 1 diagnose is required'))
      .required(t('Diagnosis array is required')),
    supportingInfos: Yup.array()
      .of(supportingInfoSchema)
      .min(1, t('At least 1 supporting info is required'))
      .required(t('Supporting info array is required'))
      .test('required-categories', function (supportingInfos) {
        const { claimType, isNewBorn } = this.parent;

        // Define required categories for each claim type
        const requiredCategoriesByType = {
          professional: [
            'chief-complaint',
            'vital-sign-weight',
            'vital-sign-diastolic',
            'vital-sign-height',
            'vital-sign-systolic',
            'treatment-plan',
            'history-of-present-illness',
            'patient-history',
            'physical-examination',
            'pulse',
            'oxygen-saturation',
            'temperature',
            'respiratory-rate',
            'investigation-result'
          ],
          institutional: [
            'chief-complaint',
            'vital-sign-weight',
            'vital-sign-diastolic',
            'vital-sign-height',
            'vital-sign-systolic',
            'treatment-plan',
            'history-of-present-illness',
            'patient-history',
            'physical-examination',
            'estimated-Length-of-Stay',
            'pulse',
            'oxygen-saturation',
            'temperature',
            'respiratory-rate',
            'investigation-result'
          ],
          oral: [
            'chief-complaint',
            'treatment-plan',
            'history-of-present-illness',
            'patient-history',
            'physical-examination',
            'investigation-result'
          ],
          vission: [
            'treatment-plan',
            'history-of-present-illness',
            'patient-history',
            'physical-examination',
            'investigation-result'
          ],
          pharmacy: [
            'treatment-plan',
            'history-of-present-illness',
            'patient-history',
            'physical-examination',
            'investigation-result'
          ]
        };

        // Initial required categories based on claim type
        let requiredCategories = [...(requiredCategoriesByType[claimType] || [])];

        // Add newborn-specific categories when applicable
        if (isNewBorn) {
          if (claimType === 'professional') {
            requiredCategories.push('birth-weight');
          } else if (claimType === 'institutional') {
            requiredCategories.push('birth-weight', 'admission-weight');
          }
        } else {
          // Remove newborn-specific categories if isNewBorn is false
          requiredCategories = requiredCategories.filter(
            category => category !== 'birth-weight' && category !== 'admission-weight'
          );
        }

        // Extract the categories present in supportingInfos
        const categories = supportingInfos ? supportingInfos.map(info => info.category) : [];

        // Check for missing categories
        const missingCategories = requiredCategories.filter(category => !categories.includes(category));

        // If there are missing categories, return a validation error message
        if (missingCategories.length > 0) {
          return this.createError({
            message: `The following categories are missing for ${claimType} type${
              isNewBorn ? ' (Newborn)' : ''
            }: ${missingCategories.join(', ')}`
          });
        }

        return true;
      }),
    items: Yup.array()
      .of(
        Yup.object().shape({
          // Define the schema for supporting info object here
        })
      )
      .min(1, t('At least 1 item is required'))
    // Define the schema for the remaining fields here
  });
